import ApplicationController from './application_controller';
/**
 * Makes table rows clickable, navigating to a URL when clicked.
 *
 * Usage:
 *   <tr data-controller="clickable-row"
 *       data-href="/path/to/resource"
 *       data-action="click->clickable-row#navigate">
 *     ...
 *   </tr>
 *
 * Clicks on links, buttons, or form elements within the row are ignored,
 * allowing those elements to function normally.
 */
export default class extends ApplicationController {
  navigate(event) {
    // Don't navigate if clicking on interactive elements within the row
    if (event.target.closest('a, button, input, select, textarea, [role="button"]')) {
      return;
    }

    const { href } = this.element.dataset;
    if (href) {
      Turbo.visit(href);
    }
  }
}
